import EditorRoutes from 'foundation/EditorRoutes';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import StudyDesignPrintView from 'studies/workspace/design/StudyDesignPrintView';
import {renderReactComponent} from 'util/RootReactRender';

export const StudyRoutes: RouteBundle = {
  domain: 'studies',
  routes: [
    {urlPattern: 'study-schemas/listing', handler: EditorRoutes.studySchemas.bind(EditorRoutes)},
    {urlPattern: 'study-schemas/create', handler: EditorRoutes.studySchemasCreate.bind(EditorRoutes)},
    {urlPattern: 'study-schemas/:id', handler: EditorRoutes.studySchema.bind(EditorRoutes)},
    {
      urlPattern: 'studies/:studyId/design/view',
      handler: (studyId: string): void => {
        DatadogUtil.startRUMView('study_design_view');
        renderReactComponent(StudyDesignPrintView, {studyId});
      },
    },
  ],
};
